export default __webpack_public_path__ + "static/media/eraser.d2df166e.svg";